export default "/_next/static/chunks/fonts/Advance-Design-System-Icon-1c653cd83314da517dd37bdfdeab383b.ttf";